import { CameraType } from '../../../../data/media';
import events from 'APP_ROOT/data/events';

var lastKnownEventId = null; // used to detect switching between events
var forcingDefaultCameraTypeForEventType = false; // if switching to an event with a default cameraType (e.g. RAV-582)

const getEventId = (event) => {
    return event ? event.get('eventId') : null;
};

const getEventType = (event) => {
    return event ? event.get('type') : null;
};

const getDefaultCameraTypeForEventType = (eventType) => {

    let foundEvent = events.find(e => e.proto.name === eventType);
    if (foundEvent) {
      return  foundEvent.defaultCameraType;
    }

    switch (eventType) {
        case "EVENT_RAVEN_UNPLUGGED":
        case "EVENT_RAVEN_USER_SHUTDOWN":
        case "EVENT_KLOUD_DRIVER_DETECTED":
        case "EVENT_KLOUD_PASSENGER_DETECTED":
        case "EVENT_STORAGE_SD_CARD_REMOVED":
        case "EVENT_KLOUD_DRIVER_DISTRACTED_CELLPHONE":
            return CameraType.CAMERA_CABIN;
        default:
            return null;
    }
}

const getCameraType = (cameraType, event) => {
    // check if switching to a new event (to enforce a default camera type on switch)
    const eventType = getEventType(event);
    const defaultCameraTypeForEventType = getDefaultCameraTypeForEventType(eventType);
    const eventId = getEventId(event);
    if (lastKnownEventId !== eventId) { // also handles case where lastKnownEventId is null

        lastKnownEventId = eventId;

        if (defaultCameraTypeForEventType &&                // only force if there is a default for this type and ...
            defaultCameraTypeForEventType !== cameraType) { // ... if it's actually different than the currently selecrted cameraType
            forcingDefaultCameraTypeForEventType = true;
        } else {
            forcingDefaultCameraTypeForEventType = false;
        }
    }

    if (forcingDefaultCameraTypeForEventType) {  // mapStateToProps is called multiple times during event selection. This flag persists across those updates
        return defaultCameraTypeForEventType;
    }

    return cameraType;

};

const clearCameraTypeOverride = () => {
    forcingDefaultCameraTypeForEventType = false;
};

export default {
    getCameraType,
    clearCameraTypeOverride
};
